import React from 'react'

import i18n from 'live/services/i18n'

import { AlarmsTitleContainer } from './styles'

export const AlarmsTitle: React.FC = () => {
    return (
        <AlarmsTitleContainer>
            <div className="text-title">{i18n('WELCOME')}</div>
            <div className="text-body">
                {i18n('Here you can create groups, edit groups and add groups to bowties.')}
            </div>
        </AlarmsTitleContainer>
    )
}
